export class GoogleForm {
    public googleMapFields = {
		street_number: {'field':'short_name','form_field':'address'},
		route: {'field':'long_name','form_field':'address'},
		locality: {'field':'long_name','form_field':'city'},
		administrative_area_level_1: {'field':'long_name','form_field':'state'},
		country: {'field':'long_name','form_field':'country'},
		postal_code: {'field':'short_name','form_field':'zipcode'},
	};
}